<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">Instructions</div>
        </template>
      </es-header>
    </div>
    <div class="content" style="padding: 0 1rem 1rem 1rem">
      <div v-if="cepTab && cepTab === 'lealist'">
        <span v-for="item in cepInstructions" :key="item.description">
          <ul>
            <li class="has-text-left">
            {{ item.description }}
            </li>
            <ul>
              <li
                class="has-text-left"
                v-for="(subitem, index) in item.subitems"
                :key="index">
              {{ subitem }}
              </li>
            </ul>
          </ul>
        </span>
      </div>
      <ol v-else>
        <li
          class="has-text-left"
          v-for="description in cepInstructions"
          :key="description.description">
        {{ description.description }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EsHeader from '@/components/EsHeader.vue';

export default {
  components: {
    EsHeader,
  },
  props: {
    cepTab: {
      type: String,
    },
  },
  computed:
  {
    ...mapGetters({
      isState: 'CEPElectionApprovalUser',
    }),
    cepInstructions() {
      if (this.cepTab && this.cepTab === 'lealist') {
        return [
          {
            description: 'To enable CEP 1 Year Renewal, perform the following steps:',
            subitems: [
              'Click the vertical ellipse icon in the Actions column.',
              'Click Enable Grace Year.',
            ],
          },
          {
            description: 'To disable CEP 1 Year Renewal, perform the following steps:',
            subitems: [
              'Click the vertical ellipse icon in the Actions column.',
              'Click Disable Grace Year.',
            ],
          },
        ];
      }
      if (this.isState) {
        return [
          {
            description: 'The State must verify and accept population and elections data prior to CEP deadlines.',
          },
          {
            description: 'To ensure up-to-date count of identified students, you should conduct one or more matches on Match Options page and resolve near matches as needed.',
          },
          {
            description: 'Once all data is verified, you could either accept or reject the data submitted by LEAs.',
          },
          {
            description: 'You could allow LEAs to resubmit population or elections data by clicking on "Reopen Submission".',
          },
        ];
      }
      return [
        {
          description: 'The SFA must verify all fields and CEP data must be as of the date specified by the State.',
        },
        {
          description: 'To ensure up-to-date count of identified students, you should conduct one or more matches on Match Options page and resolve near matches as needed.',
        },
        {
          description: 'Once all data is verified, you must certify the information by checking the box next to the certification statement.',
        },
        {
          description: 'After certifying population data, you must click the “Submit” button.',
        },
        {
          description: 'Once the population data has been submitted and accept, you are ready to start CEP elections in Elections tab.',
        },
        {
          description: 'If you need to adjust your elections for schools, groupings, or district wide, please click on “Recalculate” and go to Recalculate Worksheet.',
        },
        {
          description: 'After adjusting your elections on Recalculate Worksheet, go back to Elections tab.',
        },
        {
          description: 'After certifying elections data, you must click the “Submit” button.',
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    font-size: 12px
  .content
    padding-top: 1rem
</style>
